// Shared constants for the application

export const ZUTEILUNG_TYPES: Array<{ id: string; label: string }> = [
  { id: "Standard", label: "Standard" },
  { id: "HK", label: "HK" },
  { id: "Praktikum", label: "Praktikum" },
  { id: "SHT", label: "SHT" },
  { id: "Pool", label: "Pool" },
];

export const STATUS_THRESHOLDS = {
  UNDERLOAD: -2,
  OVERLOAD: 2,
} as const;
